import { http } from 'http';

export default {
  getMasterData: () => http.get('masterdata/fields/STRATOS/vehicle-images'),

  getIdVehicle: ({ shellType, location, brand, model, version, vehicle }) =>
    http.get(`/VehicleImages/${shellType}/${location}/${brand}/${model}/${version}/${vehicle}`),

  getVehicleById: id => http.get(`/VehicleImages/${id}`),

  getImages: id => http.get(`/VehicleImages/list/${id}`),

  getCampaignId: ({ vehicleId }) => http.get(`/VehicleImages/Campaigns/${vehicleId}`)
};
